import { useEffect, useState } from 'react'

export interface GeoPrice {
  price: string
  regularPrice: string
  currency: 'ARS' | 'USD'
  isLoading: boolean
}

const AR_PRICE: GeoPrice = {
  price: 'ARS 24.990',
  regularPrice: 'ARS 41.650',
  currency: 'ARS',
  isLoading: false,
}

const USD_PRICE: GeoPrice = {
  price: 'USD 17.99',
  regularPrice: 'USD 29.99',
  currency: 'USD',
  isLoading: false,
}

async function detectCountry(): Promise<string | null> {
  const endpoints = [
    { url: 'https://ipwho.is/', key: 'country_code' },
    { url: 'https://ipapi.co/json/', key: 'country_code' },
  ]

  for (const endpoint of endpoints) {
    try {
      const response = await fetch(endpoint.url)
      if (!response.ok) continue
      const data = (await response.json()) as Record<string, unknown>
      const code = data[endpoint.key]
      if (typeof code === 'string' && code.length === 2) {
        return code.toUpperCase()
      }
    } catch {
      // Intentamos con el siguiente proveedor
    }
  }

  return null
}

export function useGeoPrice(): GeoPrice {
  const [state, setState] = useState<GeoPrice>({ ...USD_PRICE, isLoading: true })

  useEffect(() => {
    let active = true

    detectCountry().then((country) => {
      if (!active) return
      setState(country === 'AR' ? AR_PRICE : USD_PRICE)
    })

    return () => {
      active = false
    }
  }, [])

  return state
}
